import { useStateMachine } from "little-state-machine";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { updateEditRegionRequest } from "actions/updateEditRegionRequest";
import IEditRegionRequest from "interfaces/Request/IEditRegionRequest";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";

const EditTemplate = (props: any): any => {
  const navigate = useNavigate();
  const { actions } = useStateMachine({ updateEditRegionRequest });
  const {
    id, name, active, statusReportTimes
  } = props;

  const onEditClickHandler = () => {
    const region: IEditRegionRequest = {
      id, name, active, statusReportTimes
    };
    actions.updateEditRegionRequest(region);
    navigate(RoutePathsEnum.SettingsRegionsUpdate);
  };

  return (
    <div className="d-flex justify-content-center">
      <Button
        variant="primary"
        data-testid="edit-region"
        aria-label={`Edit ${name} region`}
        onClick={onEditClickHandler}
      >
        Edit
      </Button>
    </div>
  );
};
export default EditTemplate;
